import { CloseOutlined } from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { orderStatuses } from "../../extensions/helper";

const LicenseFilter = ({ value, onClose }) => {
  const emptyFilter = { searchText: '' };
  const [tempFilter, setTempFilter] = useState(() => {
    try {
      const saved = localStorage.getItem('licenseOrdersFilter');
      if (saved) {
        return JSON.parse(saved);
      }
    } catch {}
    return emptyFilter;
  });

  useEffect(() => {
    if (value && Object.keys(value).length > 0) {
      const normalized = { ...value };
      if (normalized.dateFrom && typeof normalized.dateFrom === 'string') {
        normalized.dateFrom = dayjs(normalized.dateFrom);
      }
      if (normalized.dateTo && typeof normalized.dateTo === 'string') {
        normalized.dateTo = dayjs(normalized.dateTo);
      }
      setTempFilter(normalized);
    }
  }, [value]);

  const onSearchChange = (changed) => {
    const text = changed.search.toLowerCase();
    setTempFilter(prev => ({ ...prev, search: text }));
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="payments-mobile-filter-container">
            <Input placeholder="Поиск по компании, email" allowClear style={{ maxWidth: 420, marginRight: 8 }}
              value={tempFilter?.search} onChange={(e) => onSearchChange({ search: e.target.value })}/>
            <Select placeholder="Статусы" mode="multiple" value={tempFilter?.statuses} onChange={(val) => setTempFilter(prev => ({ ...prev, statuses: val }))}
              options={orderStatuses} allowClear className="client-filter-select"/>
            <Button onClick={() => onClose(tempFilter)}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseFilter;
